//Helpers
import { real_id } from '../interface_helpers';
import { getComponentByDevice, getVirtualComponentsInterface } from './virtual_components_helpers';
import { getBthomedeviceComponents } from './virtual_bthome_helper';
//Types
import type { Device } from 'src/types/Device';
import type { DeviceSettingsG2 } from 'src/types/DeviceSettings';
import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';
import type {
	ComponentsGroupInterface,
	VirtualComponentInterface,
	VirtualComponentTypes,
} from 'src/types/VirtualComponents';

export const retrieveVCGroups = (
	device: Device,
	status: DeviceStatusG2,
	setting: DeviceSettingsG2,
): {
	groups: ComponentsGroupInterface[];
	components: string[];
} => {
	const groups: ComponentsGroupInterface[] = [];
	const components: string[] = [];
	const deviceID: string = real_id(device.id);
	const virtualComponents: VirtualComponentInterface[] = getVirtualComponentsInterface(deviceID);
	const trv = Object.keys(setting).filter((i) => /^(blutrv):2\d{2}$/.test(i));
	for (const component in status) {
		if (!setting[component]) {
			continue;
		} else if (/^(group|bthomedevice):2\d{2}$/.test(component)) {
			if (
				(device.channel >= 200 && component != getComponentByDevice(device)) ||
				trv.find((i) => setting[i]?.trv == component)
			) {
				continue;
			}
			const group: ComponentsGroupInterface = {
				id: setting[component]?.id,
				key: component,
				config: setting[component],
				status: status[component],
				items: [],
			};
			components.push(`${component}:${group.config?.name || ''}`);
			if (/^group:2\d{2}$/.test(component) && group.status?.value?.length) {
				group.status.value.forEach((i: string) => {
					const item = virtualComponents.find((el) => el.key == i);
					const vcView = item?.config?.['ui']?.view || item?.config?.meta?.ui?.view;
					// Virtual components can be hidden in groups using the "hidden" view settings
					// and are only visible in the Virtual Components tab.
					if (vcView || /^bthome/.test(item?.type)) {
						group.items.push({
							...item,
							id: item.config.id,
							type: item.key.split(':')[0] as VirtualComponentTypes,
						});
						components.push(item.key);
					}
					getBthomedeviceComponents(group, item);
				});
			} else if (/^bthomedevice:2\d{2}$/.test(component) && group.config?.addr) {
				const items = virtualComponents.filter((el) => el.config?.addr == group.config?.addr);
				group.items = items;
				getBthomedeviceComponents(group, group);
				components.push(items.length.toString());
			}
			groups.push(group);
		}
	}
	return { groups, components };
};
